import { useMemo } from 'react';
import { ColumnGroup } from 'react-table';

import productImg from 'assets/product.jpeg';

import * as S from 'pages/Catalogue/components/Products/Products.styles';

import { Actions } from 'components/Actions';

export const useColumns = () =>
  useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Products',
        columns: [
          {
            accessor: 'image',
            Cell: () => <S.StyledImage source={productImg} alt="example" />,
          },
          {
            Header: 'Brand',
            accessor: 'brand',
          },
          {
            Header: 'Name',
            accessor: 'name',
          },
          {
            Header: 'Category',
            accessor: 'category',
          },
          {
            Header: 'SubCategory',
            accessor: 'subCategory',
          },
          {
            accessor: 'actions',
            Cell: () => <Actions isManagePath toTheRight />,
          },
        ],
      },
    ],
    []
  );
